'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheManager = exports.COUNTRY_CACHE_MAP = void 0;
const expiry_map_1 = require("../utils/expiry-map");
/**
 * COUNTRY_CACHE_MAP
 * > Expiry Map Tree
 *
 * Country Code -> Module Key -> Expiry Map Instance
 *
 * e.g.
 * ```
 * {
 *  "SGP": {
 *    "app-features": new ExpiryMap(),
 *    "app-features.general": new ExpiryMap(),
 *    "app-features.admin": new ExpiryMap(),
 *    "app-features.customer": new ExpiryMap(),
 *    "email-templates": new ExpiryMap()
 *  },
 *  "HKG": {
 *    "app-features": ExpiryMap()
 *  }
 * }
 * ```
 */
exports.COUNTRY_CACHE_MAP = {};
/**
 * @class CacheManager
 * @description get or generates cache storage of respective country and module
 */
class CacheManager {
    constructor(tenantSettings) {
        this.tenantSettings = tenantSettings;
    }
    get countryCode() {
        return this.tenantSettings.countryCode;
    }
    static resetCache() {
        Object.keys(exports.COUNTRY_CACHE_MAP).forEach(key => {
            exports.COUNTRY_CACHE_MAP[key] = undefined;
        });
    }
    /**
     * Get cache storage of respective country and module
     * @param countryCode Country Code
     * @param key Module key (model key and sub key if available, delimited by dot (.))
     * @returns {ExpiryMap} Cache storage
     */
    getStorage(key) {
        if (!exports.COUNTRY_CACHE_MAP[this.countryCode]) {
            exports.COUNTRY_CACHE_MAP[this.countryCode] = {};
        }
        if (exports.COUNTRY_CACHE_MAP[this.countryCode][key])
            return exports.COUNTRY_CACHE_MAP[this.countryCode][key];
        exports.COUNTRY_CACHE_MAP[this.countryCode][key] = new expiry_map_1.default(this.tenantSettings.cacheExpiration);
        return exports.COUNTRY_CACHE_MAP[this.countryCode][key];
    }
}
exports.CacheManager = CacheManager;
//# sourceMappingURL=cache.manager.js.map